/**
 * Auto-generated by tools/content-pipeline.
 * Pack: wordsearch-themedshape-v1
 * Item: wordsearch-kitchen
 * Generated: 2026-06-06T02:55:50.494Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 59 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */
export const kitchenWords = [
    {
        "word": "KETTLE"
    },
    {
        "word": "SKILLET"
    },
    {
        "word": "LADLE"
    },
    {
        "word": "WHISK"
    },
    {
        "word": "SIEVE"
    },
    {
        "word": "GRATER"
    },
    {
        "word": "COLANDER"
    },
    {
        "word": "BURNER"
    },
    {
        "word": "SPATULA"
    },
    {
        "word": "FLOUR"
    },
    {
        "word": "SUGAR"
    },
    {
        "word": "SALT"
    },
    {
        "word": "BUTTER"
    },
    {
        "word": "YEAST"
    },
    {
        "word": "SYRUP"
    },
    {
        "word": "VINEGAR"
    },
    {
        "word": "HONEY"
    },
    {
        "word": "BACON"
    },
    {
        "word": "COCOA"
    },
    {
        "word": "OATS"
    },
    {
        "word": "SOUP"
    },
    {
        "word": "STEW"
    },
    {
        "word": "ROAST"
    },
    {
        "word": "BISCUIT"
    },
    {
        "word": "GRAVY"
    },
    {
        "word": "CASSEROLE"
    },
    {
        "word": "MEATLOAF"
    },
    {
        "word": "PUDDING"
    },
    {
        "word": "PANCAKE"
    },
    {
        "word": "CHOWDER"
    },
    {
        "word": "APRON"
    },
    {
        "word": "MIXER"
    },
    {
        "word": "TIMER"
    },
    {
        "word": "PANTRY"
    },
    {
        "word": "ICEBOX"
    },
    {
        "word": "CUTLERY"
    },
    {
        "word": "NAPKIN"
    },
    {
        "word": "TEAPOT"
    },
    {
        "word": "BAKING"
    },
    {
        "word": "DISHES"
    },
    {
        "word": "RECIPE"
    },
    {
        "word": "KITCHEN"
    },
    {
        "word": "CUPBOARD"
    },
    {
        "word": "FRIDGE"
    },
    {
        "word": "OVEN"
    },
    {
        "word": "RANGE"
    },
    {
        "word": "GRIDDLE"
    },
    {
        "word": "CROCKERY"
    },
    {
        "word": "POTATO"
    },
    {
        "word": "PASTA"
    },
    {
        "word": "BREAD"
    },
    {
        "word": "COOKIES"
    },
    {
        "word": "DONUTS"
    },
    {
        "word": "CAKE"
    },
    {
        "word": "JUICE"
    },
    {
        "word": "PLUNGER"
    },
    {
        "word": "WHIP"
    },
    {
        "word": "SCOOP"
    },
    {
        "word": "MEASURE"
    }
];
//# sourceMappingURL=kitchen.js.map